export class CieloCode {

    public code: string;
    public message: string;
    
    constructor() {}
}